<template>
  <transition name="fade" appear>
    <a
      :class="{ 'alternate-theme': alternateTheme }"
      v-if="external || link[0] === '#'"
      :href="link"
      > <span>{{ text }}</span></a
    >
    <button :class="{ 'alternate-theme': alternateTheme }" v-else>
      <span>{{ text }}</span>
    </button>
  </transition>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: String,
    link: String,
    alternateTheme: Boolean,
    external: Boolean,
  },
};
</script>

<style lang="scss" scoped>
a,
button {
  font-family: "Sharp Grotesk";
  font-size: 0.825rem;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.20);
  background:  linear-gradient(180deg, #0479E8 0%, #005AB0 100%);
  color: var(--white);
  border: none;
  text-transform: uppercase;
  padding: 6px 30px;
  user-select: none;
  display: inline-block;
  position: relative;
  transition: 0.2s all ease-in-out;
  text-align: center;
  font-size: 19px;
  line-height: 1.3;
  cursor: pointer;
  &.book {
    padding:8px 16px;
  }
  span {
    position: relative;
  }  
  &.alternate-theme {
    background: var(--greyGradient);
  }
  &.selected {
    pointer-events: none;
    background: var(--blueGradient);
    span {
      color: var(--dark-red);      
    }
    &:before {
      opacity: 1;
    }
  }
  @media (hover: hover) {
    &:not(.disabled) {
      &:hover {        
        background: var(--dark-blue);
        border-bottom-color: var(--white);
      }
    }
  }
}
</style>